import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 38 63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" stroke-linejoin=\"round\" stroke-miterlimit=\"2\" viewBox=\"0 0 38 63\" id=\"arrow-right\"><path fill-rule=\"nonzero\" d=\"M1.88 1.88a6.33 6.33 0 0 1 8.95-.05l24.8 25a6.34 6.34 0 0 1 0 8.96l-25 24.8a6.33 6.33 0 0 1-8.92-8.97l20.5-20.45L1.87 10.83a6.33 6.33 0 0 1 0-8.95\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol